import { render, staticRenderFns } from "./ImageUpload.vue?vue&type=template&id=dc4d0f4a&scoped=true&"
import script from "./ImageUpload.vue?vue&type=script&lang=ts&"
export * from "./ImageUpload.vue?vue&type=script&lang=ts&"
import style0 from "./ImageUpload.vue?vue&type=style&index=0&id=dc4d0f4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4d0f4a",
  null
  
)

export default component.exports